/**
 * @file PageBgImageSection.tsx
 * @description «Картинка фона» с заголовком и пояснением — для фона
 * страницы в «Настройках страницы» (`PageBackgroundCard`; решение
 * пользователя 2026-10-06). Поля — `PageBgImageFields`; правка уходит в
 * черновик оформления, канва перекрашивается тем же живым сообщением.
 *
 * Во вкладке «Фон и рамка» те же поля стоят в группе-карточке «Картинка
 * фона» (`BackdropTab`, SB122). Заголовок здесь — уровень подгруппы
 * (`SettingsSubgroup`): панель страницы переводится на группы в шаге 6
 * SB122 (uiux-settings-groups §5).
 */

import type { SitePageBgImage, SiteTheme } from "@chaiberi/shared";

import { FieldHint, SettingsSubgroup } from "../../ui/settings-groups";
import { PageBgImageFields } from "./PageBgImageFields";

/** Пояснение «Картинки фона» — общее для группы во вкладке и для фона страницы. */
export const PAGE_BG_IMAGE_HINT =
  "Картинка под всеми блоками страницы. Для тяжёлых фото лучше затемнение и прозрачность — текст останется читаемым.";

interface Props {
  image: SitePageBgImage | null;
  onBackdrop: (patch: Partial<SiteTheme["backdrop"]>) => void;
}

export function PageBgImageSection({ image, onBackdrop }: Props) {
  return (
    <SettingsSubgroup title="Картинка фона">
      <FieldHint className="mt-0">{PAGE_BG_IMAGE_HINT}</FieldHint>
      <PageBgImageFields image={image} onBackdrop={onBackdrop} />
    </SettingsSubgroup>
  );
}
